@import 'styles/mixins';
@import 'styles/variables';

.colorIconButton {
  display: flex;
  flex-direction: column;
  padding: 6px 6px 4px;
  gap: 1px;
}

.activeTextColorsOverride {
  width: 16px;
  height: 2px;
  margin-top: -1px;
  margin-left: 0px;
  border-radius: 2px;
  overflow: hidden;

  & > div {
    border-radius: 0;
  }
}
